import { joinURLPath } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'

import { globalErrorHandler, macroCacheOptions, projectName, request, services } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)

const cachedGet = Cache.wrapWithCache(async (key, service, id) => {
  return await request.get(joinURLPath(service, id), undefined, { $scope: [ 'full' ] })
})

export default {
  name: 'Fallbacks',

  props: {
    value: {
      type: Object,
      default: undefined
    }
  },

  data() {
    return {
      loading: false,
      items: []
    }
  },

  computed: {
    itemsWithId() {
      const items = this.value?.fallbacks
      if (Array.isArray(items) && items.length) {
        return items.filter(item => {
          return item?.id
        })
      } else {
        return []
      }
    },

    itemsWithoutId() {
      const items = this.value?.fallbacks
      if (Array.isArray(items) && items.length) {
        return items.filter(item => {
          return !item?.id
        })
      } else {
        return []
      }
    }
  },

  watch: {
    itemsWithId: {
      async handler() {
        await this.get()
      },
      deep: true
    }
  },

  async mounted() {
    await this.get()
  },

  methods: {
    async get() {
      this.loading = true
      try {
        if (this.itemsWithId.length) {
          const results = await Promise.all(this.itemsWithId.map(async ({ id, $options }) => {
            const key = [ projectName, services.sendings, 'get', id ].filter(Boolean).join(':')
            const response = await cachedGet(key, services.sendings, id)
            if (response) {
              return {
                ...response,
                $options
              }
            }
          }))
          this.items = results.filter(Boolean)
        } else {
          this.items = []
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
